import React from 'react';
import { styles } from './styles';
import SectionWrapper from '../../components/sectionWrapper/sectionWrapper';
import ContactForm from '../../components/contactForm/contactForm';
import { CONTACT_EMAIL } from '../../contact/config';

const Contact: React.FC = () => {
  return (
    <SectionWrapper id="contact" label="Contact" heading="Let's build something">
      <div className="contact-inner" style={styles.inner}>
        {/* Info column */}
        <div>
          <p style={styles.infoPara}>
            Have a project in mind, or just want to learn more about what we do? Reach out. We
            respond within one business day. Every project is personally overseen by Kaan Sozer, our
            founder.
          </p>
          <div style={styles.details}>
            <div style={styles.detailItem}>
              <span style={styles.dot} />
              <a href={`mailto:${CONTACT_EMAIL}`} style={styles.link}>{CONTACT_EMAIL}</a>
            </div>
            <div style={styles.detailItem}>
              <span style={styles.dot} />
              <span>Arizona, USA</span>
            </div>
            <div style={styles.detailItem}>
              <span style={styles.dot} />
              <a href="https://novaeon.io" target="_blank" rel="noreferrer" style={styles.link}>
                novaeon.io
              </a>
            </div>
          </div>
        </div>

        {/* Form column */}
        <ContactForm
          idPrefix="contact"
          variant="novaeon"
          emailPlaceholder="you@company.com"
          messagePlaceholder="Tell us about your project or question..."
        />
      </div>
    </SectionWrapper>
  );
};

export default Contact;
